import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import ClientNavbar from "components/Navbars/ClientNavbar.js";
import Footer from "components/footer/Footer";
import clientRoutes from "clientRoutes.js";
import logo from "black-white-logo.png";
import { BackgroundColorContext } from "contexts/BackgroundColorContext";
import { useTranslation } from "../../hooks/useTranslation";

function Client(props) {
  const t = useTranslation();
  const location = useLocation();
  const mainPanelRef = React.useRef(null);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanelRef.current) {
      mainPanelRef.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < clientRoutes.length; i++) {
      if (location.pathname === clientRoutes[i].path) {
        return clientRoutes[i].name;
      }
    }
    return "Black & White";
  };

  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <React.Fragment>
          <div className="wrapper client-wrapper">
            <ClientNavbar
              brandText={getBrandText(location.pathname)}
              logo={{
                outterLink: "/",
                text: "Black&White",
                imgSrc: logo,
              }}
            />
            <div
              className="main-panel client-main-panel"
              ref={mainPanelRef}
              data={color}
              style={{ marginTop: "76px" }}
            >
              <Routes>
                {getRoutes(clientRoutes)}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Footer fluid />
            </div>
          </div>
        </React.Fragment>
      )}
    </BackgroundColorContext.Consumer>
  );
}

export default Client;
